import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UnitOfLengthModel } from '../models/unit-of-length.model';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Manages units of length
 */
@Injectable({
  providedIn: 'root'
})
export class UnitOfLengthService {
  /**
   * Unit of length resource
   */
  private _unitOfLengthResource: string;

  /**
   * Constructor
   * @param httpClient HttpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._unitOfLengthResource = this.appServiceHelper.getServiceEndpoint('pollux.api', 'unitOfLength');
  }

  /**
   *Loads the defined units of length
   */
  loadUnitsOfLength(): Observable<UnitOfLengthModel[]> {
    return this.httpClient.get<UnitOfLengthModel[]>(`${this._unitOfLengthResource}`);
  }
}
